import { useState, useEffect } from "react";
import { Menu, Select, Popover } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useSelector, useDispatch, themeActions } from "src/redux/store";
import { LogoIcon, AccountIcon, LocaleIcon } from "src/assets/images";
import PersonalPanel from "../personalPanel";

const Navigataor = styled.div`
    position: fixed;
    width: 100%;
    z-index: 1000;
    top: 0;
    box-shadow: 0 2px 4px #777777;
    display: grid;
    grid-template: auto / auto 1fr repeat(2, auto);
    background: #fff;
    padding: 0 30px;

    .logo-button {
        margin: auto;
        cursor: pointer;
    }

    .svg-button {
        margin: auto 0 auto 20px;
    }

    .ant-select-selector {
        padding: 0 11px 0 32px !important;
    }
`;

export default (props) => {
    const { menuConfig } = props;
    const [selectedKey, setSelectedKey] = useState([]); // menu key
    const [menuItems, setMenuItems] = useState([]);
    const [menuPaths, setMenuPaths] = useState([]);
    const [mode, setMode] = useState("horizontal");
    const { functions } = useSelector((state) => state.aclReducer);
    const { theme } = useSelector((state) => state.themeReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getMenuItems = (menuItems, functions = []) =>
        menuItems.filter((item) => {
            const func = functions.find((func) => func.function_id == item.key);
            if (func) {
                if (item.children?.length) {
                    item.children = getMenuItems(item.children, func.child_functions);
                } else {
                    // Remove empty submenu
                    delete item.children;
                }
                return true;
            }
        });

    const getMenuPaths = (menuItems) => {
        let paths = [];
        menuItems.forEach((item) => {
            if (item.children?.length) paths = [...paths, ...getMenuPaths(item.children)];
            else paths.push({ path: item.path, key: item.key });
        });
        return paths;
    };

    const onResize = () => {
        setMode(window.innerWidth < 768 ? "inline" : "horizontal");
    };

    const onMenuClick = (e) => {
        if (e.item.props.path) navigate(e.item.props.path);
        else if (e.item.props.url) window.open(e.item.props.url).focus();
    };

    const onLangChange = (value) => {
        localStorage.setItem("locale", value);
        dispatch(themeActions.setLocale(value));
    };

    // Recover selectedKey when url is changed
    useEffect(() => {
        const key = menuPaths.find((x) => x.path === window.location.pathname)?.key;
        setSelectedKey([`${key}`]);
    }, [menuPaths, window.location.pathname]);

    useEffect(() => {
        // Initialize i18n
        onLangChange(localStorage.getItem("locale") || "en");

        // Filter menu item by functions
        const menuItems = getMenuItems(menuConfig, functions);
        const menuPaths = getMenuPaths(menuItems);
        setMenuItems(menuItems);
        setMenuPaths(menuPaths);

        onResize();
        window.addEventListener("resize", onResize);
    }, []);

    return <Navigataor>
        <LogoIcon className="logo-button" onClick={() => navigate("/")}/>
        <Menu
            selectedKeys={selectedKey}
            mode={mode}
            theme={theme}
            style={{ flex: 1 }}
            // overflowedIndicator={<MenuButton icon={<EllipsisOutlined />} name={"More"} />}
            items={menuItems}
            onClick={onMenuClick}
        />
        <Select
            style={{ width: "130px", margin: "auto" }}
            options={[
                { value: "en", label: "English" },
                { value: "zh-TW", label: "中文(台灣)" }
            ]}
            suffixIcon={<>
                <LocaleIcon width="16" height="16" style={{ position: "absolute", left: "-100px" }}/>
                <div style={{
                    border: "5px solid transparent",
                    borderTopColor: "#052733",
                    marginTop: "5px",
                    width: 0,
                    height: 0
                }} />
            </>}
            onChange={onLangChange}
            defaultValue={localStorage.getItem("locale") || "en"}
        />
        <Popover
            placement="bottomRight"
            trigger="hover"
            content={<PersonalPanel />}
        >
            <AccountIcon className="svg-button" width="30" height="30" />
        </Popover>
    </Navigataor>;
};
